module.exports = {
      id: "live-chat-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#live-chat",
      toString: function () {
        return this.url;
      }
    }